/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { Databases, ID, Storage } from 'appwrite';
import appwriteClient from '../appwrite.config';
import Cookies from 'js-cookie';
import { 
  Form, Input, Button, Card, Row, Col, Typography, Space, 
  Tag, Divider, Modal, message, Upload, List, InputNumber 
} from 'antd';
import { Select } from 'antd';
import { 
  PlusOutlined, DeleteOutlined, EnvironmentOutlined, LoadingOutlined,
  StarOutlined, StarFilled,
} from '@ant-design/icons';
const { Title, Text } = Typography;
const { TextArea } = Input;


// Constants
const MAPS_API_KEY = "AIzaSyBR4Z3kCrFWW6fnwScXcyqGlKAgUEh7AcU";
const DATABASE_ID = 'AppwriteCloudFEApp';
const COLLECTION_ID = '65ea96670e2c9740a984';
const STORAGE_BUCKET = 'fleetPhotos';
const DEFAULT_LOCATION = { lat: 20.5937, lng: 78.9629 }; // Center of India

// Performance optimization: Only load map script once
const loadScriptProps = {
  googleMapsApiKey: MAPS_API_KEY,
  loadingElement: <div>Loading Map...</div>
};

// TagInput component for multi-value inputs - Extracted as separate component
const TagInput = React.memo(({ label, fieldName, items, inputValue, onChange, onAdd, placeholder, required = false }) => (
  <Form.Item label={label} required={required} labelCol={{ span: 24 }}>
    <Space direction="vertical" style={{ width: '100%' }}>
      <Input.Group compact>
        <Input
          style={{ width: 'calc(100% - 60px)' }}
          value={inputValue}
          onChange={(e) => onChange(fieldName, e.target.value)}
          placeholder={placeholder}
          onPressEnter={() => onAdd(fieldName)}
        />
        <Button type="primary" onClick={() => onAdd(fieldName)}>Add</Button>
      </Input.Group>
      <div style={{ marginTop: 8 }}>
        {items?.map((item, index) => (
          <Tag key={index} closable onClose={() => onChange('remove', { field: fieldName, index })} style={{ marginBottom: 8 }}>
            {item}
          </Tag>
        ))}
      </div>
    </Space>
  </Form.Item>
));

function loadGoogleMapsScript() {
  return new Promise((resolve, reject) => {
    if (window.google && window.google.maps) {
      resolve(window.google.maps);
      return;
    }

    // Check if script is already being loaded
    const existingScript = document.getElementById('google-maps-script');
    if (existingScript) {
      existingScript.addEventListener('load', () => {
        if (window.google && window.google.maps) {
          resolve(window.google.maps);
        } else {
          reject(new Error('Google Maps not available after script load'));
        }
      });
      return;
    }

    // Create script element
    const script = document.createElement('script');
    script.id = 'google-maps-script';
    script.src = `https://maps.googleapis.com/maps/api/js?key=${MAPS_API_KEY}&libraries=places`;
    script.async = true;
    script.defer = true;
    
    script.addEventListener('load', () => {
      if (window.google && window.google.maps) {
        resolve(window.google.maps);
      } else {
        reject(new Error('Google Maps not available after script load'));
      }
    });
    
    script.addEventListener('error', (e) => {
      reject(new Error('Error loading Google Maps script'));
    });
    
    document.head.appendChild(script);
  });
}


function FleetProfileCreation({ isUpdation, id, onSuccess }) {
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();
  
  // Initialize services once
  const databases = useMemo(() => new Databases(appwriteClient), []);
  const storage = useMemo(() => new Storage(appwriteClient), []);
  const [loading, setLoading] = useState(false);
  
  // Split state into different slices to reduce unnecessary re-renders
  const [basicInfo, setBasicInfo] = useState({
    fleetName: "", 
    whatsappNumber: "", 
    contactNumber: "", 
    gst: "", 
    officeAddress: "",
    noOfVehicle: "",
  });
  
  const [arrayFields, setArrayFields] = useState({
    email: [],
    loadingMaterial: [], 
    pndl: [], 
    retreader: [],
    route: [], 
    vehicleProfiles: []
  });
  
  const [locationInfo, setLocationInfo] = useState({
    fleetLocationLat: "", 
    fleetLocationLong: "",
  });
  
  const [contactPersons, setContactPersons] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [fleetPhotos, setFleetPhotos] = useState([]);

  const { Option } = Select;
  
  // UI state
  const [inputValues, setInputValues] = useState({
    email: "", 
    loadingMaterial: "", 
    pndl: "", 
    retreader: "", 
    route: "", 
    vehicleProfile: "",
    contactPerson: { name: "", role: "", number: "" },
    vehicle: { type: "", quantity: "" }
  });
  
  const [fileList, setFileList] = useState([]);
  const [mapState, setMapState] = useState({
    visible: false,
    center: DEFAULT_LOCATION,
    marker: DEFAULT_LOCATION
  });

const [zones, setZones] = useState([]);
const [selectedZones, setSelectedZones] = useState([]);
const [previousZones, setPreviousZones] = useState([]);



useEffect(() => {
  // Fetch zones from the database
  databases.listDocuments(DATABASE_ID, "ZoneRegister", [])
    .then((response) => {
      setZones(response.documents);
    })
    .catch((error) => {
      console.error("Error fetching zones:", error);
      messageApi.error("Failed to load zones");
    });
}, [databases]);
  
// 2. Remove the existing LoadScript imports and components
// Instead of using <LoadScript>, modify your useEffect to load Google Maps

// Add this state to track Google Maps loading
const [mapsLoaded, setMapsLoaded] = useState(false);

// Add this useEffect at the top level of your component
useEffect(() => {
  let isMounted = true;
  
  loadGoogleMapsScript()
    .then(() => {
      if (isMounted) {
        setMapsLoaded(true);
      }
    })
    .catch(error => {
      console.error("Error loading Google Maps:", error);
      if (isMounted) {
        messageApi.error("Failed to load Google Maps. Please refresh the page.");
      }
    });
    
  return () => {
    isMounted = false;
  };
}, []);
  
  const [preview, setPreview] = useState({
    open: false,
    image: '',
    title: ''
  });

  // Memoize the form values to reduce re-renders
  const formValues = useMemo(() => ({
    ...basicInfo,
    ...locationInfo
  }), [basicInfo, locationInfo]);

  // Memoize map center to prevent unnecessary re-renders
  const mapCenter = useMemo(() => {
    if (locationInfo.fleetLocationLat && locationInfo.fleetLocationLong) {
      const lat = parseFloat(locationInfo.fleetLocationLat);
      const lng = parseFloat(locationInfo.fleetLocationLong);
      if (!isNaN(lat) && !isNaN(lng)) {
        return { lat, lng };
      }
    }
    return DEFAULT_LOCATION;
  }, [locationInfo.fleetLocationLat, locationInfo.fleetLocationLong]);

  // Memoize map marker to prevent unnecessary re-renders
  const mapMarker = useMemo(() => {
    if (mapState.marker) {
      return mapState.marker;
    }
    if (locationInfo.fleetLocationLat && locationInfo.fleetLocationLong) {
      const lat = parseFloat(locationInfo.fleetLocationLat);
      const lng = parseFloat(locationInfo.fleetLocationLong);
      if (!isNaN(lat) && !isNaN(lng)) {
        return { lat, lng };
      }
    }
    return null;
  }, [mapState.marker, locationInfo.fleetLocationLat, locationInfo.fleetLocationLong]);

  // Load data for editing
  useEffect(() => {
    if (!isUpdation || !id) return;
    
    setLoading(true);
    databases.getDocument(DATABASE_ID, COLLECTION_ID, id)
      .then((response) => {
        console.log("Loaded document:", response);

    if (response.zones) {
  // Handle different formats of zones data
  if (Array.isArray(response.zones)) {
    setSelectedZones(response.zones);
    setPreviousZones(response.zones);
  } else if (typeof response.zones === 'string') {
    setSelectedZones([response.zones]);
    setPreviousZones([response.zones]);
  }
} else {
  // Find zones that have this fleet in their fleetProfile
  databases.listDocuments(DATABASE_ID, "ZoneRegister")
    .then((zoneRes) => {
      const fleetZones = zoneRes.documents.filter(zone => {
        // Make sure zone.fleetProfile exists and is an array
        if (!zone.fleetProfile) return false;
        
        // Convert to array if it's not already
        const fleetProfileArray = Array.isArray(zone.fleetProfile) ? zone.fleetProfile : [zone.fleetProfile];
        
        // Check if this fleet is in the zone's fleetProfile
        return fleetProfileArray.some(fleet => {
          if (typeof fleet === 'object') {
            return fleet.$id === id;
          }
          return fleet === id;
        });
      });
      
      const zoneIds = fleetZones.map(zone => zone.$id);
      setSelectedZones(zoneIds);
      setPreviousZones(zoneIds);
      
      // Update form field
      form.setFieldsValue({ zones: zoneIds });
    })
    .catch(error => {
      console.error("Error finding fleet zones:", error);
      messageApi.error("Failed to determine fleet zones");
    });
}
        
        // Process photos
        let photos = [];
        if (response.fleetPhoto) {
          // Handle different formats of fleetPhoto
          if (typeof response.fleetPhoto === 'string') {
            // Single URL string
            photos = [{ 
              id: 'imported-1', 
              url: response.fleetPhoto,
              name: 'Image 1'
            }];
          } else if (Array.isArray(response.fleetPhoto)) {
            // Array of strings or objects
            photos = response.fleetPhoto.map((photo, index) => {
              if (typeof photo === 'string') {
                return { 
                  id: `imported-${index}`, 
                  url: photo,
                  name: `Image ${index + 1}`
                };
              } else {
                return { 
                  id: photo.id || `imported-${index}`,
                  url: typeof photo.url === 'string' ? photo.url : photo?.url?.toString() || photo,
                  name: photo.name || `Image ${index + 1}`
                };
              }
            });
          }
        }
        
        // Prepare fileList for Upload component
        const photoFileList = photos.map((photo, index) => ({
          uid: photo.id || `-${index}`,
          name: photo.name || `Image ${index + 1}`,
          status: 'done',
          url: photo.url,
        }));
        
        setFileList(photoFileList);
        setFleetPhotos(photos);
        
        // Set map location
        if (response.fleetLocationLat && response.fleetLocationLong) {
          const lat = parseFloat(response.fleetLocationLat);
          const lng = parseFloat(response.fleetLocationLong);
          
          if (!isNaN(lat) && !isNaN(lng)) {
            setMapState(prev => ({
              ...prev,
              center: { lat, lng },
              marker: { lat, lng }
            }));
            
            setLocationInfo({
              fleetLocationLat: response.fleetLocationLat,
              fleetLocationLong: response.fleetLocationLong
            });
          }
        }
        
        // Process arrays safely
        const safeArray = field => Array.isArray(response[field]) ? response[field] : 
                                  (response[field] ? [response[field]] : []);
        
        // Combine contact person details
        const contactPersons = [];
        const contactPersonNames = safeArray('contactPersonName');
        const contactPersonRoles = safeArray('contactPersonRole');
        const contactPersonNumbers = safeArray('contactPersonNumber');
        
        // Find the max length to ensure we capture all data
        const maxContactLength = Math.max(
          contactPersonNames.length,
          contactPersonRoles.length,
          contactPersonNumbers.length
        );
        
        for (let i = 0; i < maxContactLength; i++) {
          contactPersons.push({
            name: contactPersonNames[i] || "",
            role: contactPersonRoles[i] || "",
            number: contactPersonNumbers[i] || ""
          });
        }
        
        setContactPersons(contactPersons);
        
        // Combine vehicle details
        const vehicles = [];
        const vehicleTypes = safeArray('vehicleType');
        const vehicleQuantities = safeArray('vehicleQuantity');
        
        const maxVehicleLength = Math.max(
          vehicleTypes.length,
          vehicleQuantities.length
        );
        
        for (let i = 0; i < maxVehicleLength; i++) {
          vehicles.push({
            type: vehicleTypes[i] || "",
            quantity: vehicleQuantities[i] || ""
          });
        }
        
        setVehicles(vehicles);
        
        // Update basic information
        setBasicInfo({
          fleetName: response.fleetname || "",
          contactNumber: response.contactNumber || "",
          whatsappNumber: response.whatsappNumber || "",
          gst: response.gst || "",
          officeAddress: response.officeAddress || "",
          noOfVehicle: response.noOfVehicle || "",
        });
        
        // Update array fields
        setArrayFields({
          email: safeArray('email'),
          loadingMaterial: safeArray('loadingMaterial'),
          pndl: safeArray('pndLocation'),
          retreader: safeArray('retreader'),
          route: safeArray('route'),
          vehicleProfiles: safeArray('vehicleProfiles')
        });
        
        // Update form fields
        form.setFieldsValue({
          fleetName: response.fleetname || "",
          whatsappNumber: response.whatsappNumber || "",
          contactNumber: response.contactNumber || "",
          gst: response.gst || "",
          officeAddress: response.officeAddress || "",
          fleetLocationLat: response.fleetLocationLat || "",
          fleetLocationLong: response.fleetLocationLong || "",
          noOfVehicle: response.noOfVehicle || ""
        });
      })
      .catch((error) => {
        messageApi.error("Error occurred while fetching data");
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [isUpdation, id]);

  // Handle form field changes, ensuring they update both in Form and our state
  const handleFormChange = useCallback((changedValues, allValues) => {
    // Update basicInfo state
    setBasicInfo(prev => ({
      ...prev,
      ...changedValues
    }));
    
    // Update locationInfo state if lat/long changed
    if (changedValues.fleetLocationLat || changedValues.fleetLocationLong) {
      setLocationInfo(prev => ({
        ...prev,
        ...changedValues
      }));
    }
  }, []);

  // Handler for tag input changes
  const handleInputChange = useCallback((field, value) => {
    if (field === 'remove') {
      // Handle removing items from arrays
      const { field: arrayField, index } = value;
      setArrayFields(prev => ({
        ...prev,
        [arrayField]: prev[arrayField].filter((_, i) => i !== index)
      }));
      return;
    }
    
    if (field.startsWith('contactPerson.')) {
      // Handle contact person fields
      const contactField = field.split('.')[1];
      setInputValues(prev => ({
        ...prev,
        contactPerson: {
          ...prev.contactPerson,
          [contactField]: value
        }
      }));
      return;
    }
    
    if (field.startsWith('vehicle.')) {
      // Handle vehicle fields
      const vehicleField = field.split('.')[1];
      setInputValues(prev => ({
        ...prev,
        vehicle: {
          ...prev.vehicle,
          [vehicleField]: value
        }
      }));
      return;
    }
    
    // Handle simple fields
    setInputValues(prev => ({
      ...prev,
      [field]: value
    }));
  }, []);

  // Add item to array fields
  const addArrayItem = useCallback((field) => {
    const value = inputValues[field];
    if (!value || !value.trim()) {
      messageApi.warning(`Please enter a value for ${field}`);
      return;
    }
    
    setArrayFields(prev => ({
      ...prev,
      [field]: [...prev[field], value.trim()]
    }));
    
    // Clear input
    setInputValues(prev => ({
      ...prev,
      [field]: ""
    }));
  }, [inputValues, messageApi]);

  // Add contact person
  const addContactPerson = useCallback(() => {
    const { name, role, number } = inputValues.contactPerson;
    
    if (!name.trim() || !role.trim() || !number.trim()) {
      messageApi.warning("Please fill all contact person fields");
      return;
    }
    
    setContactPersons(prev => [
      ...prev, 
      {
        name: name.trim(),
        role: role.trim(),
        number: number.trim()
      }
    ]);
    
    // Reset inputs
    setInputValues(prev => ({
      ...prev,
      contactPerson: { name: "", role: "", number: "" }
    }));
  }, [inputValues.contactPerson, messageApi]);

  // Remove contact person
  const removeContactPerson = useCallback((index) => {
    setContactPersons(prev => prev.filter((_, i) => i !== index));
  }, []);

  // Add vehicle
  const addVehicle = useCallback(() => {
    const { type, quantity } = inputValues.vehicle;
    
    if (!type.trim() || !quantity) {
      messageApi.warning("Please fill both vehicle type and quantity");
      return;
    }
    
    setVehicles(prev => [
      ...prev,
      {
        type: type.trim(),
        quantity: quantity.toString()
      }
    ]);
    
    // Reset inputs
    setInputValues(prev => ({
      ...prev,
      vehicle: { type: "", quantity: "" }
    }));
  }, [inputValues.vehicle, messageApi]);

  // Remove vehicle
  const removeVehicle = useCallback((index) => {
    setVehicles(prev => prev.filter((_, i) => i !== index));
  }, []);

  // Handle map click
  const handleMapClick = useCallback((event) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();
    
    setMapState(prev => ({
      ...prev,
      marker: { lat, lng }
    }));
    
    // Update both form and location state
    const newLocationInfo = {
      fleetLocationLat: lat.toString(),
      fleetLocationLong: lng.toString()
    };
    
    form.setFieldsValue(newLocationInfo);
    setLocationInfo(newLocationInfo);
  }, [form]);

  // Apply map location
  const applyMapLocation = useCallback(() => {
    const { marker } = mapState;
    if (marker) {
      const newLocationInfo = {
        fleetLocationLat: marker.lat.toString(),
        fleetLocationLong: marker.lng.toString()
      };
      
      form.setFieldsValue(newLocationInfo);
      setLocationInfo(newLocationInfo);
      setMapState(prev => ({ ...prev, visible: false }));
    } else {
      messageApi.warning("Please select a location on the map first");
    }
  }, [form, mapState, messageApi]);

  // Handle image upload
  const handleUpload = useCallback(async ({ file, onSuccess, onError }) => {
    try {
      const fileId = ID.unique();
      
      await storage.createFile(STORAGE_BUCKET, fileId, file);
      const fileUrl = storage.getFileView(STORAGE_BUCKET, fileId);
      
      const newPhoto = {
        id: fileId,
        url: fileUrl,
        name: file.name
      };
      
      setFleetPhotos(prev => [...prev, newPhoto]);
      onSuccess("ok");
    } catch (error) {
      console.error("Upload error:", error);
      onError(error);
    }
  }, [storage]);

  // Handle image preview
  const handlePreview = useCallback(async (file) => {
    // If it's a file uploaded from the local system
    if (!file.url && !file.preview) {
      file.preview = await new Promise(resolve => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    
    const image = file.url || file.preview;
    setPreview({
      open: true,
      image: image,
      title: file.name || 'Preview'
    });
  }, []);

  // Handle image removal
  const handleImageRemove = useCallback((file) => {
    const index = fileList.findIndex(item => item.uid === file.uid);
    if (index !== -1) {
      // Remove from fileList state
      setFileList(prev => prev.filter(item => item.uid !== file.uid));
      
      // Remove from fleetPhotos state
      setFleetPhotos(prev => prev.filter((_, i) => i !== index));
    }
  }, [fileList]);

  // Update fileList when fleetPhotos change
  useEffect(() => {
    // Convert fleetPhotos to fileList format
    const newFileList = fleetPhotos.map((photo, index) => ({
      uid: photo.id || `-${index}`,
      name: photo.name || `Image ${index + 1}`,
      status: 'done',
      url: photo.url,
    }));
    
    setFileList(newFileList);
  }, [fleetPhotos]);

  // Submit form
  const handleSubmit = useCallback(() => {
    form.validateFields().then(values => {
      setLoading(true);
      
      // Basic validation
      if (!values.fleetName || !values.whatsappNumber || !values.contactNumber) {
        messageApi.error("Required fields are empty");
        setLoading(false);
        return;
      }

      // Extract arrays from contactPersons
      const contactPersonName = contactPersons.map(person => person.name);
      const contactPersonRole = contactPersons.map(person => person.role);
      const contactPersonNumber = contactPersons.map(person => person.number);
      const contactPerson = contactPersons.map(person => 
        `${person.name} (${person.role}) - ${person.number}`
      );

      // Extract arrays from vehicles
      const vehicleType = vehicles.map(vehicle => vehicle.type);
      const vehicleQuantity = vehicles.map(vehicle => vehicle.quantity);
      const vehicle = vehicles.map(vehicle => 
        `${vehicle.type} - ${vehicle.quantity}`
      );

      // Update form values with latest from state
      const updatedValues = {
        ...values,
        ...locationInfo
      };

      // Prepare document data
      const documentData = {
        fleetname: updatedValues.fleetName,
        contactNumber: updatedValues.contactNumber,
        whatsappNumber: updatedValues.whatsappNumber,
        email: arrayFields.email,
        contactPerson: contactPerson,
        contactPersonName: contactPersonName,
        contactPersonRole: contactPersonRole,
        contactPersonNumber: contactPersonNumber,
        vehicle: vehicle,
        vehicleType: vehicleType,
        vehicleQuantity: vehicleQuantity,
        noOfVehicle: updatedValues.noOfVehicle,
        gst: updatedValues.gst,
        loadingMaterial: arrayFields.loadingMaterial,
        officeAddress: updatedValues.officeAddress,
        pndLocation: arrayFields.pndl,
        retreader: arrayFields.retreader,
        route: arrayFields.route,
        fleetLocationLat: updatedValues.fleetLocationLat,
        fleetLocationLong: updatedValues.fleetLocationLong,
        vehicleProfiles: arrayFields.vehicleProfiles,
      };

      console.log("Saving document:", documentData);

      // Save document
      const savePromise = isUpdation
        ? databases.updateDocument(DATABASE_ID, COLLECTION_ID, id, documentData)
        : databases.createDocument(
            DATABASE_ID, 
            COLLECTION_ID, 
            ID.unique(), 
            {
              ...documentData,
              createdAt: new Date().toLocaleString(),
              createdBy: Cookies.get("userName") || "Anonymous"
            }
          );
      
  savePromise.then(async(result) => {
  // Get the fleet ID - either the existing ID or the new one from the result
  const fleetId = isUpdation ? id : result.$id;
  
  // First, fetch the fresh data from the database to avoid state closure issues
  try {
    // Fetch the current fleetProfile data for all zones
    const zonesResponse = await databases.listDocuments(DATABASE_ID, "ZoneRegister");
    const allZones = zonesResponse.documents || [];
    
    // Get current zone assignments for this fleet from the database
    const currentAssignedZones = allZones
      .filter(zone => {
        if (!zone.fleetProfile) return false;
        const fleetProfiles = Array.isArray(zone.fleetProfile) ? 
          zone.fleetProfile : [zone.fleetProfile].filter(Boolean);
        
        return fleetProfiles.some(fp => 
          (typeof fp === 'object' && fp.$id === fleetId) || fp === fleetId
        );
      })
      .map(zone => zone.$id);
    
    // Use the values from the form/UI instead of state
    const targetZones = form.getFieldValue('zones') || [];
    
    console.log("Working with fresh database data:", {
      currentAssignedZones,
      targetZones
    });
    
    // Calculate zones to add/remove based on form values and DB data
    const zonesToAdd = targetZones.filter(zoneId => !currentAssignedZones.includes(zoneId));
    const zonesToRemove = currentAssignedZones.filter(zoneId => !targetZones.includes(zoneId));
    
    console.log("Calculated zone changes:", { zonesToAdd, zonesToRemove });
    
    // Process additions
    for (const zoneId of zonesToAdd) {
      const zoneDoc = await databases.getDocument(DATABASE_ID, "ZoneRegister", zoneId);
      let fleetProfile = zoneDoc.fleetProfile || [];
      fleetProfile = Array.isArray(fleetProfile) ? fleetProfile : [fleetProfile].filter(Boolean);
      
      if (!fleetProfile.some(fleet => {
        return (typeof fleet === 'object') ? fleet.$id === fleetId : fleet === fleetId;
      })) {
        fleetProfile.push(fleetId);
        await databases.updateDocument(DATABASE_ID, "ZoneRegister", zoneId, {
          fleetProfile: fleetProfile
        });
      }
    }
    
    // Process removals
    for (const zoneId of zonesToRemove) {
      const zoneDoc = await databases.getDocument(DATABASE_ID, "ZoneRegister", zoneId);
      let fleetProfile = zoneDoc.fleetProfile || [];
      
      // Convert to array if it's not already
      fleetProfile = Array.isArray(fleetProfile) ? fleetProfile : [fleetProfile].filter(Boolean);
      
      // Filter out this fleet from the zone's fleetProfile
      const updatedFleetProfile = fleetProfile.filter(fleet => {
        if (typeof fleet === 'object') {
          return fleet.$id !== fleetId;
        }
        return fleet !== fleetId;
      });
      
      // Update the zone document with the filtered fleetProfile
      await databases.updateDocument(DATABASE_ID, "ZoneRegister", zoneId, {
        fleetProfile: updatedFleetProfile
      });
    }
    
    // Update state only after operations are complete
    setPreviousZones(targetZones);
    setSelectedZones(targetZones);
    
    // Show success message
    messageApi.success(`Fleet profile ${isUpdation ? 'updated' : 'created'} successfully`);
    onSuccess();
  } catch (error) {
    console.error("Error updating zones:", error);
    messageApi.error("Fleet saved but zone updates failed");
  }
})
        .finally(() => {
          setLoading(false);
        });
    });
  }, [form, messageApi, isUpdation, id, databases, locationInfo, contactPersons, vehicles, arrayFields, fleetPhotos]);

  if (loading && !fileList.length) {
    return (
      <Card className="max-w-6xl mx-auto shadow-lg text-center p-8">
        <LoadingOutlined style={{ fontSize: 40 }} />
        <Title level={4} className="mt-4">Loading Fleet Profile...</Title>
      </Card>
    );
  }

  const MapComponent = React.memo(() => {
    if (!mapsLoaded) {
      return <div style={{ height: '400px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>Loading map...</div>;
    }
    
    const GoogleMap = window.google.maps.Map;
    const mapRef = React.useRef(null);
    
    useEffect(() => {
      if (!mapRef.current) return;
      
      const map = new GoogleMap(mapRef.current, {
        center: mapCenter,
        zoom: mapMarker ? 20 : 10,
      });
      
      let marker = null;
      if (mapMarker) {
        marker = new window.google.maps.Marker({
          position: mapMarker,
          map: map
        });
      }
      
      // Add click listener to the map
      map.addListener('click', (event) => {
        const lat = event.latLng.lat();
        const lng = event.latLng.lng();
        
        if (marker) {
          marker.setPosition({ lat, lng });
        } else {
          marker = new window.google.maps.Marker({
            position: { lat, lng },
            map: map
          });
        }
        
        handleMapClick(event);
      });
      
      return () => {
        window.google.maps.event.clearInstanceListeners(map);
      };
    }, [mapCenter, mapMarker, mapsLoaded]);
    
    return <div ref={mapRef} style={{ width: '100%', height: '400px' }}></div>;
  });
  
  // 4. Similarly, update the MapPreviewComponent
  const MapPreviewComponent = React.memo(() => {
    if (!locationInfo.fleetLocationLat || !locationInfo.fleetLocationLong || !mapsLoaded) {
      return null;
    }
    
    const previewCenter = {
      lat: parseFloat(locationInfo.fleetLocationLat),
      lng: parseFloat(locationInfo.fleetLocationLong)
    };
    
    const mapRef = React.useRef(null);
    
    useEffect(() => {
      if (!mapRef.current) return;
      
      const map = new window.google.maps.Map(mapRef.current, {
        center: previewCenter,
        zoom: 20,
        disableDefaultUI: true
      });
      
      new window.google.maps.Marker({
        position: previewCenter,
        map: map
      });
    }, [previewCenter, mapsLoaded]);
    
    return (
      <div 
        className="mb-4 cursor-pointer border rounded overflow-hidden" 
        onClick={() => setMapState(prev => ({ ...prev, visible: true }))}
        style={{ height: "150px", position: "relative" }}
      >
        <div style={{ position: "absolute", top: 0, right: 0, zIndex: 1, padding: "5px" }}>
          <Button size="small" type="primary" icon={<EnvironmentOutlined />}>
            View Map
          </Button>
        </div>
        <div ref={mapRef} style={{ width: '100%', height: '150px' }}></div>
      </div>
    );
  });
  

  // Memoize contact persons list for better performance
  const ContactPersonsList = React.memo(() => (
    contactPersons?.length > 0 ? (
      <List
        size="small"
        className="mt-4"
        bordered
        dataSource={contactPersons}
        renderItem={(person, index) => (
          <List.Item
            actions={[
              <Button 
                type="text" 
                danger 
                icon={<DeleteOutlined />}
                onClick={() => removeContactPerson(index)}
              />
            ]}
          >
            <div>
              <Text strong>{person.name}</Text>
              <Text type="secondary"> ({person.role}) - </Text>
              <Text>{person.number}</Text>
            </div>
          </List.Item>
        )}
      />
    ) : null
  ));

  // Memoize vehicles list for better performance
  const VehiclesList = React.memo(() => (
    vehicles?.length > 0 ? (
      <List
        size="small"
        className="mt-4"
        bordered
        dataSource={vehicles}
        renderItem={(vehicle, index) => (
          <List.Item
            actions={[
              <Button 
                type="text" 
                danger 
                icon={<DeleteOutlined />}
                onClick={() => removeVehicle(index)}
              />
            ]}
          >
            <div>
              <Text strong>{vehicle.type}</Text>
              <Text> - Qty: {vehicle.quantity}</Text>
            </div>
          </List.Item>
        )}
      />
    ) : null
  ));

  return (
    <Card className="max-w-6xl bg-gray-200 mx-auto shadow-lg">
      {contextHolder}
      <Title level={2} className="text-center mb-6">
        {isUpdation ? 'Update Fleet Profile' : 'Create New Fleet Profile'}
      </Title>

      <Form
        form={form}
        layout="vertical"
        requiredMark="optional"
        initialValues={formValues}
        onValuesChange={handleFormChange}
      >
        <Row gutter={24}>
          {/* Left Column */}
          <Col xs={24} md={12}>
            <Divider orientation="left">Basic Information</Divider>
            
            <Form.Item label="Fleet Name" name="fleetName" rules={[{ required: true }]}>
              <Input placeholder="Enter fleet name" />
            </Form.Item>
            <Form.Item label="Zones" name="zones">
  <Select
    mode="multiple"
    placeholder="Select Zones"
    value={selectedZones}
    onChange={(value) => setSelectedZones(value)}
    style={{ width: '100%' }}
  >
    {zones.map((zone) => (
      <Option key={zone.$id} value={zone.$id}>
        {zone.zoneName}
      </Option>
    ))}
  </Select>
</Form.Item>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="Whatsapp Number" name="whatsappNumber" rules={[{ required: true }]}>
                  <Input placeholder="Enter WhatsApp number" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Contact Number" name="contactNumber" rules={[{ required: true }]}>
                  <Input placeholder="Enter contact number" />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item label="GST Number" name="gst">
              <Input placeholder="Enter GST number" />
            </Form.Item>

            <Form.Item label="Office Address" name="officeAddress">
              <TextArea rows={3} placeholder="Enter office address" />
            </Form.Item>

            <TagInput
              label="P&DL Locations"
              fieldName="pndl"
              items={arrayFields.pndl}
              inputValue={inputValues.pndl}
              onChange={handleInputChange}
              onAdd={addArrayItem}
              placeholder="Enter P&DL location"
            />

            <Divider orientation="left">Location Information</Divider>
            
            <Row gutter={16}>
              <Col span={10}>
                <Form.Item label="Latitude" name="fleetLocationLat">
                  <Input placeholder="Enter latitude" />
                </Form.Item>
              </Col>
              <Col span={10}>
                <Form.Item label="Longitude" name="fleetLocationLong">
                  <Input placeholder="Enter longitude" />
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item label=" " colon={false}>
                  <Button 
                    icon={<EnvironmentOutlined />}
                    onClick={() => setMapState(prev => ({ ...prev, visible: true }))}
                    style={{ marginTop: 5 }}
                  >
                    Map
                  </Button>
                </Form.Item>
              </Col>
            </Row>

            {/* Display a small preview of the map location if coordinates are set */}
            <MapPreviewComponent />
          </Col>

          {/* Right Column */}
          <Col xs={24} md={12}>
            <Divider orientation="left">Fleet Images</Divider>

            <Upload
              listType="picture-card"
              fileList={fileList}
              onPreview={handlePreview}
              customRequest={handleUpload}
              onRemove={handleImageRemove}
              accept="image/*"
            >
              {fileList.length >= 8 ? null : (
                <div>
                  <PlusOutlined />
                  <div style={{ marginTop: 8 }}>Upload</div>
                </div>
              )}
            </Upload>

            {fileList.length > 0 && (
              <Text type="secondary" className="mt-2 block">
                Click on images to preview. You can upload up to 8 images.
              </Text>
            )}

            <Divider orientation="left">Contact Persons</Divider>
            
            <Card size="small" className="mb-4">
              <Row gutter={[16, 16]}>
                <Col span={8}>
                  <Form.Item label="Name" required={false}>
                    <Input
                      placeholder="Name"
                      value={inputValues.contactPerson.name}
                      onChange={(e) => handleInputChange('contactPerson.name', e.target.value)}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Role/Designation" required={false}>
                    <Input
                      placeholder="Role"
                      value={inputValues.contactPerson.role}
                      onChange={(e) => handleInputChange('contactPerson.role', e.target.value)}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Number" required={false}>
                    <Input
                      placeholder="Phone number"
                      value={inputValues.contactPerson.number}
                      onChange={(e) => handleInputChange('contactPerson.number', e.target.value)}
                    />
                  </Form.Item>
                </Col>
              </Row>
              
              <Button type="primary" block onClick={addContactPerson}>
                Add Contact Person
              </Button>
              
              {contactPersons?.length > 0 && (
                <List
                  size="small"
                  className="mt-4"
                  bordered
                  dataSource={contactPersons}
                  renderItem={(person, index) => (
                    <List.Item
                      actions={[
                        <Button 
                          type="text" 
                          danger 
                          icon={<DeleteOutlined />}
                          onClick={() => removeContactPerson(index)}
                        />
                      ]}
                    >
                      <div>
                        <Text strong>{person.name}</Text>
                        <Text type="secondary"> ({person.role}) - </Text>
                        <Text>{person.number}</Text>
                      </div>
                    </List.Item>
                  )}
                />
              )}
            </Card>

            <Divider orientation="left">Vehicle Information</Divider>
            
            <Card size="small" className="mb-4">
              <Row gutter={16}>
                <Col span={14}>
                  <Form.Item label="Vehicle Type" required={false}>
                    <Input
                      placeholder="Vehicle type"
                      value={inputValues.vehicle.type}
                      onChange={(e) => handleInputChange('vehicle.type', e.target.value)}
                    />
                  </Form.Item>
                </Col>
                <Col span={10}>
                  <Form.Item label="Quantity" required={false}>
                    <InputNumber
                      placeholder="Quantity"
                      style={{ width: '100%' }}
                      min={1}
                      value={inputValues.vehicle.quantity}
                      onChange={(value) => handleInputChange('vehicle.quantity', value)}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Button type="primary" block onClick={addVehicle}>
                Add Vehicle Entry
              </Button>
              
              {vehicles?.length > 0 && (
                <List
                  size="small"
                  className="mt-4"
                  bordered
                  dataSource={vehicles}
                  renderItem={(vehicle, index) => (
                    <List.Item
                      actions={[
                        <Button 
                          type="text" 
                          danger 
                          icon={<DeleteOutlined />}
                          onClick={() => removeVehicle(index)}
                        />
                      ]}
                    >
                      <div>
                        <Text strong>{vehicle.type}</Text>
                        <Text> - Qty: {vehicle.quantity}</Text>
                      </div>
                    </List.Item>
                  )}
                />
              )}
            </Card>

           

            
          </Col>
        </Row>

        <div className="mt-8 text-center">
          <Button
            type="primary"
            size="large"
            onClick={handleSubmit}
            style={{ minWidth: 200 }}
          >
            {isUpdation ? 'Update Fleet Profile' : 'Create Fleet Profile'}
          </Button>
        </div>
      </Form>

      {/* Preview Modal */}
      <Modal
        open={preview.open}
        title={preview.title}
        footer={null}
        onCancel={() => setPreview(prev => ({ ...prev, open: false }))}
      >
        <img alt="preview" style={{ width: '100%' }} src={preview.image} />
      </Modal>

      {/* Map Modal */}
      <Modal
        title="Select Location"
        open={mapState.visible}
        onCancel={() => setMapState(prev => ({ ...prev, visible: false }))}
        footer={[
          <Button key="cancel" onClick={() => setMapState(prev => ({ ...prev, visible: false }))}>
            Cancel
          </Button>,
          <Button key="apply" type="primary" onClick={applyMapLocation}>
            Apply Selected Location
          </Button>
        ]}
        width={800}
      >
       <div style={{ height: 400, width: '100%' }}>
  {mapsLoaded ? (
    <div 
      ref={(el) => {
        if (el && window.google && window.google.maps) {
          const map = new window.google.maps.Map(el, {
            center: mapState.center,
            zoom: mapState.marker ? 13 : 5,
          });
          
          let marker = null;
          if (mapState.marker) {
            marker = new window.google.maps.Marker({
              position: mapState.marker,
              map: map
            });
          }
          
          map.addListener('click', (event) => {
            const lat = event.latLng.lat();
            const lng = event.latLng.lng();
            
            if (marker) {
              marker.setPosition({ lat, lng });
            } else {
              marker = new window.google.maps.Marker({
                position: { lat, lng },
                map: map
              });
            }
            
            handleMapClick(event);
          });
        }
      }} 
      style={{ width: '100%', height: '400px' }}
    />
  ) : (
    <div style={{ height: '400px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>Loading map...</div>
  )}
  <div className="mt-4">
    <Text type="secondary">
      Click on the map to select the fleet location.
    </Text>
  </div>
</div>

      </Modal>
    </Card>
  );
}

export default FleetProfileCreation;